import { isEmpty } from 'lodash';

export const getMappedConversionForm = ({ file, ...data }: any) => {
  return {
    name: data.name,
    description: data.description,
    title: data.title,
    category: data.category,
    property: {
      iconColor: data.property.iconColor,
      textColor: data.property.textColor,
      leftColor: data.property.leftColor,
      rightColor: data.property.rightColor,
      showIcon: data.property.showIcon,
      type: data.property.type
    },
    metadata: {
      url: data.fixedUrl
    }
  };
};

export const mapUploadMediaFile = (data: any) => {
  const { file } = data;
  const formData = new FormData();
  if (!isEmpty(file)) {
    formData.append('files', file);
  }
  return formData;
};

export const getMappedConversionFormForUpdating = (previousData: any, newData: any) => {
  const rootObjectKeys = ['name', 'title', 'description', 'category'];
  const propertyKeys = ['iconColor', 'textColor', 'leftColor', 'rightColor', 'showIcon', 'type'];
  const isRootObjectUpdated = rootObjectKeys.some(property => previousData[property] !== newData[property]);
  const isPropertyObjectUpdated = propertyKeys.some(
    property => previousData.property[property] !== newData.property[property]
  );
  const isMetadataObjectUpdated = previousData.metadata?.url !== newData.fixedUrl;

  if (isRootObjectUpdated || isPropertyObjectUpdated || isMetadataObjectUpdated) {
    return {
      name: newData.name,
      description: newData.description,
      title: newData.title,
      icon: previousData.icon,
      category: newData.category,
      property: {
        iconColor: newData.property.iconColor,
        textColor: newData.property.textColor,
        leftColor: newData.property.leftColor,
        rightColor: newData.property.rightColor,
        showIcon: newData.property.showIcon,
        type: newData.property.type
      },
      metadata: {
        url: newData.fixedUrl
      }
    };
  } else {
    return null;
  }
  // return {
  //   "name": data.name,
  //   "description": data.description,
  //   "title": data.title,
  //   "category": data.category,
  //   "property": {
  //     "iconColor": data.property.iconColor,
  //     "textColor": data.property.textColor,
  //     "leftColor":data.property.leftColor,
  //     "rightColor": data.property.rightColor,
  //     "showIcon": data.property.showIcon,
  //     "type": data.property.type
  //   },
  //   "metadata": {
  //     "url": data.fixedUrl
  //   }
  // };
};
